import { Component, OnInit, Input } from '@angular/core';
import { FormControl, AbstractControl } from '@angular/forms';
import { FormErrorService } from '../../services/form-error.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-form-field-error',
    templateUrl: './form-field-error.component.html',
    styleUrls: ['./form-field-error.component.css'],
    host: { 'class': 'mat-error' },
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule
    ]
})
export class FormFieldErrorComponent implements OnInit {
    @Input() control: AbstractControl;

    constructor(public formErrorService: FormErrorService) { }

    ngOnInit(): void {
    }
}
